export const FIELD_TYPES_ALLOWED_FOR_REPEATER_LABEL = ['number', 'integer', 'text', 'textarea', 'email', 'phone', 'url', 'date', 'color']

export const SELECT_OPTIONS = [
  {
    label: 'Grouping',
    options: [
      {
        value: 'group',
        label: 'Group'
      },
      // {
      //   value: 'repeater',
      //   label: 'Repeater'
      // },
      {
        value: 'repeater_json',
        label: 'Repeater'
      }
    ]
  },
  {
    label: 'Simple fields',
    options: [
      {
        value: 'number',
        label: 'Number'
      },
      {
        value: 'integer',
        label: 'Integer'
      },
      {
        value: 'boolean',
        label: 'Boolean'
      },
      {
        value: 'text',
        label: 'Text'
      },
      {
        value: 'textarea',
        label: 'TextArea'
      },
      {
        value: 'selection',
        label: 'Selection'
      },
    ]
  },
  {
    label: 'Advanced fields',
    options: [
      {
        value: 'email',
        label: 'Email'
      },
      {
        value: 'phone',
        label: 'Phone'
      },
      {
        value: 'url',
        label: 'URL'
      },
      {
        value: 'date',
        label: 'Date'
      },
      {
        value: 'color',
        label: 'Color'
      },
      {
        value: 'wysiwyg',
        label: 'WYSIWYG'
      },
      {
        value: 'relation',
        label: 'Relation'
      },
    ]
  },
  {
    label: 'Code',
    options: [
      {
        value: 'html',
        label: 'HTML'
      },
      {
        value: 'json',
        label: 'JSON'
      },
      // {
      //   value: 'liquidTemplate',
      //   label: 'Liquid template'
      // },
    ]
  },
  {
    label: 'Media',
    options: [
      {
        value: 'image',
        label: 'Image'
      },
      {
        value: 'video',
        label: 'Video (Vimeo, YT)'
      },
    ]
  },
  {
    label: 'Other',
    options: [
      {
        value: 'custom-object',
        label: 'Custom Object'
      }
    ]
  }
]

export const TYPES_DATA = {
  boolean: {
    hint: 'Common use case would be an on / off switcher.',
    help: 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Corrupti a, doloremque voluptatem necessitatibus molestias accusamus, natus ad veritatis explicabo dolor consequatur praesentium sit repellat, qui exercitationem tenetur voluptates? Quae, ullam!'
  },
  color: {
    hint: 'Shows a color picker widget.',
    help: 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Similique non fuga velit ea, officia, ullam illum incidunt architecto molestiae asperiores nobis? Nihil dicta voluptates qui velit vel iste consequuntur magnam.'
  },
  date: {
    hint: 'Shows a date picker widget.',
    help: 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Fugit commodi a assumenda architecto necessitatibus. Iste nam molestias soluta perferendis placeat vitae veritatis facere. Quae vel deleniti, culpa ratione, sed deserunt!'
  },
  email: {
    hint: 'Accepts only correct email addresses.',
    help: 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Ut, delectus alias voluptate ratione recusandae voluptatibus debitis culpa earum rem necessitatibus voluptas sequi eos, ab dicta. Ipsum voluptatibus dolore saepe fugit!'
  },
  group: {
    hint: 'Used for grouping other fields.',
    help: 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Architecto, atque sint, beatae cumque excepturi asperiores molestias natus quaerat cupiditate quis omnis. Corporis, fugit! Exercitationem unde ab nesciunt. Iure explicabo, unde.'
  },
  html: {
    hint: 'Used to paste any HTML code.',
    help: 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Accusantium ex voluptatibus obcaecati, eligendi voluptate nostrum hic perspiciatis, optio velit, assumenda cum officia nam itaque quaerat. Aut sit laboriosam cum alias.'
  },
  image: {
    hint: 'Used to add extra images.',
    help: 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Atque qui libero itaque, quod at totam aspernatur repellat facilis mollitia, esse non? Impedit, pariatur accusamus. Dolorem accusamus doloremque, commodi nostrum natus!'
  },
  integer: {
    hint: 'Accepts only integers.',
    help: 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Voluptates, porro iste a, aut adipisci aliquid doloremque facere laudantium qui cupiditate quas consequuntur, dolorem saepe nisi velit ab mollitia nemo ipsa!'
  },
  liquidTemplate: {
    hint: 'Used to paste any Liquid code.',
    help: 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Velit perspiciatis placeat eius, dolore repudiandae a nesciunt, cupiditate corporis unde tempora sequi exercitationem ex odit ipsam nam eligendi eveniet dolor animi.'
  },
  number: {
    hint: 'Accepts any number.',
    help: 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Voluptatum facere numquam perspiciatis, asperiores adipisci praesentium accusantium, expedita exercitationem quas omnis cum reiciendis vitae laboriosam fuga ut. Non odio totam nostrum.'
  },
  phone: {
    hint: 'Accepts up to 16 digits, “-“, “+”, “(“ and “)”.',
    help: 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Repudiandae dignissimos maxime sunt beatae sed labore cum voluptatum illo blanditiis, quaerat dicta culpa quo nulla ex recusandae provident eius ut earum.'
  },
  relation: {
    hint: '',
    help: 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Ipsam nobis, cum veritatis incidunt quas adipisci et obcaecati quia quisquam voluptate similique nihil ut, fuga hic beatae recusandae velit accusamus doloribus?'
  },
  repeater: {
    hint: 'Used to create a set of fields dynamically while editing content.',
    help: 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Quasi assumenda ratione cum omnis tenetur dignissimos laboriosam eveniet quod labore, ea, iste nisi molestiae, harum ipsum nostrum veniam asperiores ipsam deleniti?'
  },
  repeater_json: {
    hint: 'Used to create a set of fields dynamically while editing content.',
    help: 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Quasi assumenda ratione cum omnis tenetur dignissimos laboriosam eveniet quod labore, ea, iste nisi molestiae, harum ipsum nostrum veniam asperiores ipsam deleniti?'
  },
  selection: {
    hint: 'Accepts only integers.',
    help: 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Veniam perspiciatis delectus dolores modi illo velit esse odio quisquam eligendi corporis qui, earum cupiditate, amet cumque minus iure distinctio repellat sapiente.'
  },
  text: {
    hint: 'Regular Text input.',
    help: 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Dignissimos, maiores magnam accusamus nam. Alias obcaecati natus culpa porro, quis fuga quos quisquam itaque autem laudantium architecto perspiciatis sapiente veniam et.'
  },
  textarea: {
    hint: 'Regular TextArea input.',
    help: 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Molestiae illo quas nostrum, voluptates unde libero. Quidem maiores, tempora aliquid ratione itaque totam nesciunt nobis illo ipsam eos ab quia laudantium?'
  },
  url: {
    hint: 'Accepts only correct URL links eg. https://airnauts.com',
    help: 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Ducimus voluptatem laudantium iusto, consequatur error suscipit numquam praesentium neque! Deserunt voluptatibus saepe veritatis unde quasi sequi animi asperiores ut labore iste.'
  },
  video: {
    hint: 'Accepts only links from Vimeo.com or YouTube.com.',
    help: 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Consequuntur quae veniam saepe, et nisi, iure reiciendis recusandae in nulla eligendi doloribus unde quas commodi possimus. Rem harum eaque rerum, minima.'
  },
  wysiwyg: {
    hint: 'Shows a TinyMCE editor.',
    help: 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Eius molestiae iusto saepe perferendis, corporis, unde iure quidem beatae minima doloremque debitis ipsam eligendi vitae quia natus repellendus facere dolores at.'
  },
}


// WEBPACK FOOTER //
// ./src/components/forms/field-types.js